var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596168",
    fillRule: "evenodd",
    d: "M12 8.01l-1-.714V2.2A1.2 1.2 0 009.8 1H2.2A1.2 1.2 0 001 2.2v8.6A1.2 1.2 0 002.2 12h1.948c.42.379.879.716 1.365 1H2a2 2 0 01-2-2V2a2 2 0 012-2h8a2 2 0 012 2v6.01zm1.402 3.484l-4.19 2.993a.539.539 0 01-.852-.439v-1.407c-2.661-.297-4.84-2.733-5.348-4.778a.468.468 0 01.166-.472.473.473 0 01.663.061A5.248 5.248 0 008.36 9.454V8.062a.539.539 0 01.851-.438l4.19 2.993a.539.539 0 010 .877zM2.5 2h6a.5.5 0 110 1h-6a.5.5 0 010-1zm0 2h4a.5.5 0 010 1h-4a.5.5 0 010-1zm0 2h2a.5.5 0 010 1h-2a.5.5 0 010-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCsv);
export default ForwardRef;